import React from "react"
import { Form, Button } from "react-bootstrap"

class Login extends React.Component {
	constructor(props) {
		super(props)
		this.state = { ...props }
		if (this.state.image_preview === undefined)
			this.state.image_preview = ""
		if (this.state.message === undefined)
			this.state.message = {
				text: "",
				mode: "",
				icon: ""
			}
		if (this.state.whileSubmit === undefined) this.state.whileSubmit = false
	}
	handleSubmit = (e, x) => {
		e.preventDefault()
		e.formData = new FormData(e.target)
		e.formData.append("firebase", this.state.app.fireBaseToken)
		this.state.fn.post({
			url: "login",
			header: { "Content-type": "multipart/form-data", reset: 1 },
			data: e.formData,
			success: this.state.fn.logIn
		})
	}
	handleImagePreview = (e) => {
		this.setState({
			image_preview: URL.createObjectURL(e.target.files[0]),
			files: e.target.files[0]
		})
	}

	render() {
		return this.renderLogin()
	}
	
	renderLogin = () => {
		return (
			<div className="Login">
				<Form
					onSubmit={this.handleSubmit}
					className="p-4 border shadow-sm"
				>
					<Form.Group size="lg" controlId="email">
						<Form.Label>Email</Form.Label>
						<Form.Control
							required={true}
							autoFocus
							type="text"
							value={this.state.email}
							onChange={(e) =>
								this.setState({ email: e.target.value })
							}
							autoComplete={"off"}
							name={"email"}
						/>
					</Form.Group>
					<Form.Group size="lg" controlId="password" className="my-1">
						<Form.Label>Password</Form.Label>
						<Form.Control
							required={true}
							type="password"
							value={this.state.password}
							autoComplete={"off"}
							onChange={(e) =>
								this.setState({ password: e.target.value })
							}
							name={"password"}
						/>
					</Form.Group>
					<Form.Group size="lg" controlId="message">
						<Form.Label className={this.state.message.mode}>
							<b>
								{this.state.message.icon !== "" &&
								this.state.message.icon !== undefined ? (
									<>
										<span
											className={this.state.message.icon}
										></span>
										<span className="mx-2">
											{this.state.message.text !==
											undefined
												? this.state.message.text
												: ""}
										</span>
									</>
								) : (
									this.state.message.text
								)}
							</b>
						</Form.Label>
					</Form.Group>
					<Button type="submit" className="mt-2 mr-2">
						Login
					</Button>
				</Form>
			</div>
		)
	}
}
export default Login
